/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetThreadSuggestedPromptsResponse
 */
export interface GetThreadSuggestedPromptsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetThreadSuggestedPromptsResponse
     */
    suggestedPrompts: Array<string>;
}

/**
 * Check if a given object implements the GetThreadSuggestedPromptsResponse interface.
 */
export function instanceOfGetThreadSuggestedPromptsResponse(value: object): value is GetThreadSuggestedPromptsResponse {
    if (!('suggestedPrompts' in value) || value['suggestedPrompts'] === undefined) return false;
    return true;
}

export function GetThreadSuggestedPromptsResponseFromJSON(json: any): GetThreadSuggestedPromptsResponse {
    return GetThreadSuggestedPromptsResponseFromJSONTyped(json, false);
}

export function GetThreadSuggestedPromptsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetThreadSuggestedPromptsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestedPrompts': json['suggestedPrompts'],
    };
}

export function GetThreadSuggestedPromptsResponseToJSON(json: any): GetThreadSuggestedPromptsResponse {
    return GetThreadSuggestedPromptsResponseToJSONTyped(json, false);
}

export function GetThreadSuggestedPromptsResponseToJSONTyped(value?: GetThreadSuggestedPromptsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'suggestedPrompts': value['suggestedPrompts'],
    };
}

